import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import {NotificationProvider} from "./util/provider/NotificationProvider";
import {persistor, store} from "./store";
import {PersistGate} from "redux-persist/integration/react";
import {AppRouter} from "@/router/router.tsx";
import {ToastContainer} from "react-toastify";

const rootElement = document.getElementById("root");

if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <NotificationProvider/>
                    <BrowserRouter>
                        <AppRouter/>
                        <ToastContainer/>
                    </BrowserRouter>
                </PersistGate>
            </Provider>
        </React.StrictMode>
    );
}
